/**
 * WordPress dependencies
 */
import { createBlobURL } from '@wordpress/blob';
export function filePasteHandler(files) {
  return files.filter(_ref => {
    let {
      type
    } = _ref;
    return /^image\/(?:jpe?g|png|gif|webp)$/.test(type);
  }).map(file => `<img src="${createBlobURL(file)}">`).join('');
}
//# sourceMappingURL=file-paste-handler.js.map